export default "__VITE_ASSET__Bz84IaAi__"